// extracted by mini-css-extract-plugin
export var formContainer = "_ec-0";
export var message = "_ec-1";